import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const THEMES = {
  dark: 'dark',
  light: 'light'
};

export function ThemeProvider({ children }) {
  // Initialize from localStorage or default to dark
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('msp-theme');
      return saved || THEMES.dark;
    }
    return THEMES.dark;
  });

  // Apply theme to document
  useEffect(() => {
    const root = document.documentElement;
    
    // Remove both classes first
    root.classList.remove('dark', 'light');
    
    // Add the current theme class
    root.classList.add(theme);
    
    // Also set data attribute for more specific CSS targeting
    root.setAttribute('data-theme', theme);
    
    // Persist to localStorage
    localStorage.setItem('msp-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === THEMES.dark ? THEMES.light : THEMES.dark);
  };

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === THEMES.dark,
    isLight: theme === THEMES.light
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
